﻿/*(function () {*/
function ColourPicker() {
    const container = document.querySelector('.colour-picker-container');
    const picker = document.querySelector('.colour-picker');
    if (!picker) return;
    const listContainer = picker.querySelector('.colour-picker-list-container');
    const list = picker.querySelector('.colour-picker-list');
    if (!picker || !list) {
        console.error('Colour picker or list not found');
        return;
    }
    const items = list.querySelectorAll('.colour-picker-item');
    const links = list.querySelectorAll('.colour-picker-link');
    const currentColourLabel = createCurrentColourLabel();
    const currentColourLabelName = currentColourLabel.querySelector('.colour-picker-current-name');

    currentColourLabelName.textContent = picker.dataset.currentName || '';

    const handleColourClick = (e) => {
        e.preventDefault();
        const link = e.currentTarget;
        const swatchId = link.dataset.swatchId;
        const name = link.dataset.name;
        const hex = link.dataset.hex;
        if (!swatchId || !name) return;
        currentColourLabel.querySelector('.colour-picker-current-name').innerText = name;
        picker.setAttribute('data-current-swatch-id', swatchId);
        picker.setAttribute('data-current-name', name);
        picker.setAttribute('data-current-hex', hex);
        picker.style.setProperty('--current-colour', swatchId);
        picker.style.setProperty('--current-colour-name', name);
    };

    links.forEach((link) => { link.addEventListener('click', handleColourClick); });

    function createCurrentColourLabel() {
        const el = document.createElement('span');
        const strong = document.createElement('strong');
        const span = document.createElement('span');
        strong.innerText = 'Colour ';
        el.classList.add('colour-picker-current');
        span.classList.add('colour-picker-current-name');
        strong.classList.add('hidden');
        el.appendChild(strong);
        el.appendChild(span);
        picker.prepend(el);
        return el;
    }

    return {
        container,
        picker,
        listContainer,
        list,
        items,
        links,
        currentColourLabel,
        currentColourLabelName,
        handleColourClick
    };
}
const colourPicker = new ColourPicker();
export { colourPicker }
/*})();*/